export default "__VITE_ASSET__B6i93aTJ__"